import type { Existencia, Producto, UnidadVenta } from '@abastece/core';
import { UBICACIONES_FIJAS, ZERO_QTY, type Milli } from '@abastece/shared';
import { lecturaConDesactivados } from './catalogo.js';

/**
 * A product scanned on «Inventario»: whether the shop has it, and where (the owner, 2026-10-04).
 */

/**
 * The place listed even with nothing there: the shop, the one there is (the owner, 2026-10-05).
 * Anywhere else, the storeroom, repacking, an old truck, is listed only while it holds something.
 */
const SIEMPRE: readonly string[] = ['tienda'];

export interface EnLugar {
  ubicacion: string;
  cantidad: Milli;
}

/** Repacking after the shop and the storeroom, as the location filter lists it, then the trucks. */
function rango(ubicacion: string): number {
  const i = (UBICACIONES_FIJAS as readonly string[]).indexOf(ubicacion);
  return i < 0 ? UBICACIONES_FIJAS.length : i;
}

/** A product's stock place by place: the shop always, then wherever else some is. */
export function existenciaPorLugar(existencias: readonly Existencia[], productoId: string): EnLugar[] {
  // One row per product and place (`existenciaId`), so a place's row is its stock.
  const suyas = new Map(existencias.filter((e) => e.productoId === productoId).map((e) => [e.ubicacion, e.cantidad]));
  const otras = [...suyas.keys()]
    .filter((u) => !SIEMPRE.includes(u) && suyas.get(u) !== 0)
    .sort((a, b) => rango(a) - rango(b) || a.localeCompare(b));
  return [...SIEMPRE, ...otras].map((ubicacion) => ({ ubicacion, cantidad: suyas.get(ubicacion) ?? ZERO_QTY }));
}

/**
 * The products a code read there belongs to, each once, should two of its presentations carry it.
 * Off sale too: what is on the shelf is stock whether it is sold or not, and the list shows it. But a
 * product on sale with the code is the one meant, over one taken off sale that still has it.
 */
export function productosDelCodigo(
  productos: readonly Producto[],
  unidades: readonly UnidadVenta[],
  codigo: string,
): Producto[] {
  return [...new Map(lecturaConDesactivados(productos, unidades, codigo).map(({ producto }) => [producto.id, producto])).values()];
}
